const KEY = 'teacher-overview-section';
export function explicitTeacherSection(search = window.location.search): string | null {
  const params = new URLSearchParams(search);
  return params.has('section') ? params.get('section') : params.get('section_id');
}
export function preferredTeacherSection(sections: Array<{ id: number }>): number | null {
  const explicit = explicitTeacherSection();
  const requested = Number(explicit ?? savedTeacherSection());
  const match = sections.find(section => section.id === requested);
  // A bookmark must never open a different class.
  return match?.id ?? (explicit !== null ? null : sections[0]?.id ?? null);
}
export function rememberTeacherSection(id: number | string | null) {
  try { if (id !== null) sessionStorage.setItem(KEY, String(id)); } catch { /* Optional preference. */ }
}
export function savedTeacherSection(): string {
  try { return sessionStorage.getItem(KEY) || 'all'; } catch { return 'all'; }
}
export function teacherClassLink(to: string, section = explicitTeacherSection() ?? savedTeacherSection()): string {
  if (!to.startsWith('/v2/teacher')) return to;
  const url = new URL(to, window.location.origin);
  const own = explicitTeacherSection(url.search);
  url.searchParams.delete('section_id');
  if (own !== null || section) url.searchParams.set('section', own ?? section);
  return url.pathname + url.search + url.hash;
}
